import { render, staticRenderFns } from "./Preisdaten.vue?vue&type=template&id=13ab73cd"
import script from "./Preisdaten.vue?vue&type=script&lang=js"
export * from "./Preisdaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ab73cd')) {
      api.createRecord('13ab73cd', component.options)
    } else {
      api.reload('13ab73cd', component.options)
    }
    module.hot.accept("./Preisdaten.vue?vue&type=template&id=13ab73cd", function () {
      api.rerender('13ab73cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Preisdaten.vue"
export default component.exports